/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cli_SubInputs */

const en_mk_cli_sub = /** @type {(inputs: Mk_Cli_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your computer and agent through CLI, skills, hooks, or MCP. Run a single task or coordinate an agent team from the same plan.`)
};

const id_mk_cli_sub = /** @type {(inputs: Mk_Cli_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan komputer dan agent melalui CLI, skill, hook, atau MCP. Jalankan satu tugas atau kelola tim agent dari rencana yang sama.`)
};

/**
* | output |
* | --- |
* | "Connect your computer and agent through CLI, skills, hooks, or MCP. Run a single task or coordinate an agent team from the same plan." |
*
* @param {Mk_Cli_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cli_sub = /** @type {((inputs?: Mk_Cli_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cli_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cli_sub(inputs)
	return en_mk_cli_sub(inputs)
});